
export const landerMutations = {

    setLanderData: function (state, data) {
        this.commit('setProduct', data.product);
        this.commit('setLander', data.lander);
        this.commit('setOptions', data.options);
        this.commit('setOffer', data.offer);
        this.commit('setBenefits', data.benefits);
        this.commit('setCurrency', data.currency);
        this.commit('setGateway', data.gateway);
        this.commit('setPixels', data.pixels);
        this.commit('setExitOffer', data.exitOffer);
        this.commit('setDrugName', data.drugName);
        this.commit('setMerchant', data.merchant);
        this.commit('setGift', data.gift);
        this.commit('setSocial', data.social);
        this.commit('setInfo', data.info);
        this.commit('setSpin', data.spin);
        

        if(data.prospect) {
            this.commit('setProspect', data.prospect);
        }
        if(data.primary) {
            this.commit('setPrimary', data.primary);
        }
    },

    setProduct: (state, product) => { state.lander.server.product = product; },
    setLander: (state, lander) => { state.lander.server.lander = lander; },
    setOptions: (state, options) => { state.lander.server.options = options; },
    setOffer: (state, offer) => { state.lander.server.offer = offer; },
    setBenefits: (state, benefits) => { state.lander.server.benefits = benefits; },
    setCurrency: (state, currency) => { state.lander.server.currency = currency; },
    setGateway: (state, gateway) => { state.lander.server.gateway = gateway; },
    setPixels: (state, pixels) => { state.lander.server.pixels = pixels; },
    setExitOffer: (state, exitOffer) => { state.lander.server.exitOffer = exitOffer; },
    setDrugName: (state, drugName) => { state.lander.server.drugName = drugName; },
    setMerchant: (state, merchant) => { state.lander.server.merchant = merchant; },
    setGift: (state, gift) => { state.lander.server.gift = gift; },
    setSocial: (state, social) => { state.lander.server.social = social; },
    setInfo: (state, info) => { state.lander.server.info = info; },
    setPrimary: (state, primary) => { state.lander.server.primary = primary; },
    setSpin: (state, spin) => { state.lander.server.spin = spin; },
    setProspect(state, prospect) { state.lander.server.prospect = prospect; },
    setTrustPilot: (state, trustPilot) => { state.lander.server.trustPilot = trustPilot },
    setPlanTypeLabel: (state, planTypeLabel) => { state.lander.server.planTypeLabel = planTypeLabel },

    setLanderApiUrl: (state, landerApiUrl)  => { state.lander.client.landerApiUrl = landerApiUrl; },
    setUpsellActionUrl: (state, upsellActionUrl)  => { state.lander.client.upsellActionUrl = upsellActionUrl; },
    setBusy: (state, busy)  => { state.lander.client.busy = busy; },
    setLanderLoading: (state, loading)  => { state.lander.client.loading = loading; },
    setLanderReady: (state)  => { state.lander.client.ready = true; },
    showProspectForm: (state, visible)  => { state.lander.client.showProspectForm = visible; },
    setPreAnimCompleted: (state)  => { state.lander.client.preAnimCompleted = true; },
    setSpinCompleted: (state)  => { state.lander.client.spinCompleted = true; },
    setVirtualOfferCode: (state, virtualOfferCode)  => { state.lander.client.virtualOfferCode = virtualOfferCode; },
    setScrollTrackingPaused: (state, paused)  => { state.lander.client.scrollTrackingPaused = paused; },
    setExitPopCompleted: (state)  => { state.lander.client.exitPopCompleted = true; },
    setExitPopCancelled: (state)  => { state.lander.client.exitPopCancelled = true; },
    setSurveyCompleted: (state)  => { state.lander.client.surveyCompleted = true; },
    setAgeVerified: (state)  => { state.lander.client.ageVerified = true; },
    disableUnloadHandler: (state)  => { state.lander.client.disableUnloadHandler = true;},
    setUserSubscribed: (state) => { state.lander.client.userSubscribed = true },
    setMerchantCss: (state, merchantCss) => { state.lander.client.merchantCss = merchantCss },
    setMerchantTheme: (state, merchantTheme) => { state.lander.client.merchantTheme = merchantTheme },
    setWindowSize: (state)  => {
        state.lander.client.windowSize = {
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
        };
    },
    showTrustPilotBox: (state, show) => { state.lander.client.showTrustPilotBox = show }
}
